import { getHistoricalData } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { formatDate_YMDHMS, roundDateToFloor } from "@/_core/_helpers/_helpers";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves historical commodity technical analysis data from the API gateway.
 *
 * @param {object} _this - The context object containing relevant data.
 * @param {object} [assetExtraParams={}] - Additional parameters related to the commodity.
 * @param {number} assetExtraParams.commodityNumber - The primary identifier for the commodity.
 * @param {number} assetExtraParams.contract - The contract identifier for the commodity.
 * @returns {Promise<object>} A promise resolving to the historical commodity data.
 */
export function getCandleCommodities(_this, assetExtraParams = {}) {
  const variables = {
    format: "json",
    observation_date: formatDate_YMDHMS(
      roundDateToFloor(_this.initCommodityDate),
    ),
    commodity: assetExtraParams.commodityNumber,
    contract: assetExtraParams.contract,
  };
  let boolContract = true; // Boolean flag to verify if selected contract matches.
  if (_this.commodityDefs !== undefined) {
    let keys = Object.keys(_this.commodityDefs);
    if (keys.includes("selected_contract")) {
      boolContract =
        _this.commodityDefs.selected_contract === assetExtraParams.contract;
    }
  }
  return getHistoricalData(_this, {
    fetch: gatewayService.commodities.technicalAnalysis,
    variables,
    source: "commodity_technical_analysis_historical",
    boolContract,
  }).catch((error) => {
    console.error("Error from technical_analysis_historical:", error);
    throw error;
  });
}
